module.exports = __webpack_public_path__ + "static/media/elixir-signages-img-1.383103d0.jpg";